import { mdiFileDocumentOutline } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { canViewOrganizationSettings } from "../../../../_shared/_logic/access"
import { pageConfig as emailPage } from "./pages/Email/config"
import { pageConfig as smsPage } from "./pages/Sms/config"
import { pageConfig as whatsAppPage } from "./pages/WhatsApp/config"
import { pageConfig as phonePage } from "./pages/Phone/config"
import { pageConfig as letterPage } from "./pages/Letter/config"
import type { TemplateSelection } from "./_shared/_logic/announcement-templates-types"

export type {
  EditableDigitalChannel,
  TemplateChannel,
  TemplateSelection,
} from "./_shared/_logic/announcement-templates-types"

const pages = [emailPage, smsPage, whatsAppPage, phonePage, letterPage]

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "announcement-templates",
  title: "Ankündigungsvorlagen",
  tooltip:
    "Texte für Terminankündigungen und Verschiebungen per E-Mail, SMS, WhatsApp, Telefon und Brief bearbeiten.",
  icon: mdiFileDocumentOutline,
  routeSegment: "announcement-templates",
  getPages: (context) => {
    if (!canViewOrganizationSettings(context)) return []

    return pages.filter((page) => {
      if (
        (page.id === "sms" || page.id === "whatsapp") &&
        !context.tariffCapabilities.hasMobileMessage
      )
        return false

      return page.id !== "phone" || context.tariffCapabilities.hasPhone
    })
  },
}

export const getTabs = (context: OrgaViewFrameContext) =>
  subviewConfig.getPages(context).flatMap((page) => page.tabs ?? [])

export const resolveTemplateSelection = (id: string): TemplateSelection | null => {
  for (const page of pages) {
    const tab = page.tabs?.find((tab) => tab.id === id)

    if (tab)
      return {
        channel: page.id as TemplateSelection["channel"],
        purpose: tab.id.slice(page.id.length + 1),
      }
  }

  return null
}
